import { EAccountUpdateType } from '../../account';
import { ApiProperty, PickType } from '../../codegen';
import { IsEnum, IsNumber, IsString } from '../../validators';
import { Subscription } from '../subscription/subscription.entity';

import { Account } from './account.entity';
import { BillingTask } from './task.entity';

export class AccountSelfReturnDto extends PickType(Account, [
  'id',
  'balance',
  'balancePaid',
] as const) {}

export class AccountSSEBalanceReturnDto {
  @ApiProperty()
  @IsEnum(EAccountUpdateType, { groups: ['error'] })
  updateType: EAccountUpdateType.balance;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  balance: number;
}

export class AccountSSETaskReturnDto extends PickType(BillingTask, [
  'status',
  'context',
  'billingTaskType',
  'billingPacket',
  'coins',
]) {
  @ApiProperty()
  @IsEnum(EAccountUpdateType, { groups: ['error'] })
  updateType: EAccountUpdateType.taskStatus;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  taskId: number;
}

export class AccountSSESubscriptionReturnDto extends PickType(Subscription, [
  'id',
  'currentPlan',
  'until',
  'prolongFailedCount',
  'entityName',
  'entityId',
  'nextPlan',
  'nextPlanPaidUntil',
]) {
  @ApiProperty()
  @IsEnum(EAccountUpdateType, { groups: ['error'] })
  updateType: EAccountUpdateType.subscription;
}

export class AccountSSETableUpdated {
  @ApiProperty()
  @IsEnum(EAccountUpdateType, { groups: ['error'] })
  updateType: EAccountUpdateType.table;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  table: string;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  groupId?: number;
}
